// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","burgerMenuContainer":"burgerMenu_burgerMenuContainer__mwaQm","burgerMenuItem":"burgerMenu_burgerMenuItem__1SbW5","active":"burgerMenu_active__2QtZL"};